import {
  CATEGORY_ORDER,
  GAME_OVERRIDES,
  GENERAL_GAME_ID,
  GENERAL_PATH_PREFIXES,
  MARKETING_GAMES,
} from "./marketingGameConfig";

export function getAssetCategory(assetPath: string): string {
  const parts = assetPath
    .replace(/^(Images|Videos)\//, "")
    .split("/")
    .filter(Boolean);

  if (parts[0] === "Games" && parts.length > 1) {
    if (parts[1] === "Posters") return "Posters";
    return parts[1];
  }

  return parts[0] ?? "Other";
}

export function resolveGameId(assetPath: string): string {
  if (GAME_OVERRIDES[assetPath]) {
    return GAME_OVERRIDES[assetPath];
  }

  if (GENERAL_PATH_PREFIXES.some((prefix) => assetPath.startsWith(prefix))) {
    return GENERAL_GAME_ID;
  }

  const haystack = assetPath.toLowerCase();

  let bestGameId: string | null = null;
  let bestKeywordLength = 0;

  for (const game of MARKETING_GAMES) {
    for (const keyword of game.keywords) {
      const normalized = keyword.toLowerCase();
      if (
        haystack.includes(normalized) &&
        normalized.length > bestKeywordLength
      ) {
        bestGameId = game.id;
        bestKeywordLength = normalized.length;
      }
    }
  }

  return bestGameId ?? GENERAL_GAME_ID;
}

type GroupedAssets<T> = {
  folderName: string;
  items: T[];
};

export function filterAndGroupAssets<T extends { gameId: string; category: string }>(
  groups: GroupedAssets<T>[],
  selectedGame: string
): GroupedAssets<T>[] {
  if (selectedGame === "all") {
    return groups;
  }

  const byCategory = new Map<string, T[]>();

  for (const group of groups) {
    for (const item of group.items) {
      if (item.gameId !== selectedGame) continue;
      const existing = byCategory.get(item.category) ?? [];
      existing.push(item);
      byCategory.set(item.category, existing);
    }
  }

  return Array.from(byCategory.entries())
    .sort(
      ([a], [b]) =>
        (CATEGORY_ORDER.indexOf(a) === -1 ? 999 : CATEGORY_ORDER.indexOf(a)) -
        (CATEGORY_ORDER.indexOf(b) === -1 ? 999 : CATEGORY_ORDER.indexOf(b))
    )
    .map(([category, items]) => ({
      folderName: category,
      items,
    }));
}
